import { combineReducers } from 'redux';
import availabilityReducer from './availabilityReducer';

const reducer = combineReducers(
    {
      availabilityReducer
    });

export default reducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js